import React from 'react';
import {
    Grid,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export function BaseDialog({ thumbnail, title, text, children, actions }) {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Grid item>
            <Button onClick={handleClickOpen}>
                <img className="thumbnails" src={thumbnail} alt={title} loading="lazy" />
            </Button>

            <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} maxWidth="md" fullWidth>
                <DialogTitle sx={{ m: 0, p: 2 }}>
                    {title}
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers sx={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Grid container justifyContent="center" sx={{ '& img': { maxWidth: '100%', height: 'auto', display: 'block' }, '& video': { maxWidth: '100%', height: 'auto', display: 'block' }, '& embed': { maxWidth: '100%' } }}>
                        <Grid item sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
                            {children}
                        </Grid>
                    </Grid>
                    <Typography gutterBottom sx={{ textAlign: 'center', mt: 2 }}>
                        {text}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    {actions && actions(handleClose)}
                    <Button autoFocus onClick={handleClose} color="secondary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    );
}
